import type { ReactNode } from 'react';
import { connect } from '@atlassian/jira-react-redux';
import type { CategoryGuid } from '@atlassian/jira-servicedesk-knowledge-services/src/types';
import { getProjectKey, getBaseUrl } from '../../../state/selectors/base';
import { getCategoryName } from '../../../state/selectors/categories';
import type { State } from '../../../state/types';
import CategoryBreadcrumbItem from './view';

type OwnProps = {
	id: CategoryGuid;
	children: ReactNode;
};

type StateProps = {
	name: string | undefined;
	baseUrl: string;
	projectKey: string;
};

export default connect(
	(state: State, props: OwnProps): StateProps => ({
		name: getCategoryName(state, props.id),
		projectKey: getProjectKey(state),
		baseUrl: getBaseUrl(state),
	}),
	{},
)(CategoryBreadcrumbItem);
